import { default as AccessDenied } from './AccessDenied';

export default AccessDenied;
